const GRAPHQL_ERROR_TRANSLATIONS = {
    ORGANIZATION_LIMIT_REACHED: "subscriptionLimit.organization_limit_reached",
    SUBSCRIPTION_LIMIT_REACHED: "subscriptionLimit.limit_reached",
    SUBSCRIPTION_FEATURE_REQUIRED: "subscriptionLimit.feature_required",
};

function getGraphQLError(error) {
    return error?.graphQLErrors?.[0]
        || error?.networkError?.result?.errors?.[0]
        || (error?.extensions?.code ? error : null);
}

export function getLocalizedGraphQLError(error, t, fallbackKey = "errors.somethingWentWrong") {
    const graphQLError = getGraphQLError(error);
    const code = graphQLError?.extensions?.code;
    const translationKey = GRAPHQL_ERROR_TRANSLATIONS[code];

    if (translationKey) {
        if (code === "SUBSCRIPTION_FEATURE_REQUIRED" || code === "SUBSCRIPTION_LIMIT_REACHED") {
            return t(translationKey);
        }

        return t(translationKey, {
            limit: graphQLError.extensions.limit,
            item: graphQLError.extensions.item,
        });
    }

    return error?.message || graphQLError?.message || t(fallbackKey);
}
